import React from 'react';
import { useTranslation } from 'react-i18next';

import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_LIST } from 'settings/gtm/gtmPageView';

import styles from './ContentWithoutResult.module.scss';

type PropsType = { title: string };

export default function ContentWithoutResult({
  title,
}: PropsType): JSX.Element {
  const { t } = useTranslation('listingPage');

  useGtmPageView(GTM_PAGE_LIST, title, {
    isLoaded: true,
  });

  return (
    <div>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.message}>{t('NO_RESULT')}</div>
    </div>
  );
}
